module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "fma1"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }), _vm._v(" "), _c('div', {
    staticClass: "blockq1a"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Oh for the swords of former time!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Oh for the men who bore them,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When, arm’d for Right, they stood sublime,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("And tyrants crouch’d before them.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("When free yet, ere courts began")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("With honours to enslave him,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The best honours worn by Man")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Were those which Virtue gave him.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-r"
  }, [_vm._v("–Thomas Moore")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The work of an early twentieth century historian named Joseph Clayton (1867–1943) is fascinating reading for any student of radical history. Educated at Worcester College, Oxford, he later moved to Leeds where he became a member of the local Independent Labour Party in 1896."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach01_1",
      "id": "ch01_1"
    }
  }, [_vm._v("1")])]), _vm._v(" He considered himself a Christian Socialist and, throughout his life, wrote a number of articles on various left-wing matters, including advocating for the extension of the franchise to women, and he also wrote several history books on the radical tradition in England. His first notable work in this area was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Robert Owen, Pioneer of Social Reforms")]), _vm._v(" (1908), a biography of one of the more enlightened factory owners in the nineteenth century. After this followed, in quick succession, the following: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wat Tyler and the Peasants’ Revolt")]), _vm._v(" (1909) and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The True Story of Jack Cade")]), _vm._v(" (1910).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, two further books by Clayton really caught my eye as I was perusing his work: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Leaders of the People")]), _vm._v(" (1910) and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Rise of the Democracy")]), _vm._v(" (1911). These two books were an account of every prominent radical society and rebel leader that ever graced the annals of English history, and the great march of democracy in the country. In Clayton’s opinion, British democracy was the envy of the world:")]), _vm._v(" "), _c('div', {
    staticClass: "blockq"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Our business here is to give some plain account of the movement towards democracy in England, only touching incidentally on the progress of that movement in other parts of the world. Mainly through British influences the movement has become worldwide; and the desire for national self-government, and the adoption of the political instruments of democracy—popular enfranchisement and the rule of elected representatives—are still the aspirations of civilised man in East and West. The knowledge that "), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _vm._v("these forms of democratic government have by no means at all times and in all places proved successful does not check the movement. As the British Parliament and the British Constitution have in the past been accepted as a model in countries seeking free political institutions, so today our Parliament and our Constitutional Government are still quoted with approval and admiration in those lands where these institutions are yet to be tried."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach01_2",
      "id": "ch01_2"
    }
  }, [_vm._v("2")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("That was certainly a very patriotic view of the development of British democracy and was certainly influenced by the Whig tradition of history, in which history is the story of progress. And while many of the peoples of the British Empire did indeed desire self-government, it was not always granted willingly. The British response to Gandhi’s campaigns for independence, which were almost contemporary to Clayton’s writings, was to lock up Gandhi up in prison. Clayton’s work is now rather dated. There have been numerous advances in historical scholarship since he wrote "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Rise of the Democracy")]), _vm._v(", while Clayton’s works were targeted towards young adult readers. I felt, therefore, it was time to produce an updated similar work, with a more mature audience in mind, with a slightly different theme.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The overall theme of this volume is therefore to give an account of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("some")]), _vm._v(" of the major events, and the actions of famous English radicals from the medieval period to the nineteenth century. The question remains to be asked, then: what does it mean to be radical? There are of course many definitions of the term and there are many forms of radicalism. I take the definition of radicalism offered by the historian Michael J. Turner: this does not seek to impose a specific ideology on to the idea of radicalism—for radicals come from across the political spectrum—but rather it can be applied to any actors or ideology which seeks a fundamental change in the constitution of society, and argues that the root of society’s social and economic problems is political. The problems facing society are usually attributed to the operations of a corrupt state and selfish elite who legislate for policies that worked in their favour to the detriment of the people. Yet it is not enough for radicals simply to moan about the status quo; they also have to present an appealing vision of a better, future society to their readers and work towards it."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach01_3",
      "id": "ch01_3"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That being said, the history of English radicalism is much broader than one book could ever hope to treat in depth. Had I had my own way, the book would probably have totalled about a million words and sold in several volumes containing the lives of every British freedom fighter and radical intellectual, from Boudicca to the poll tax rioters under Margaret Thatcher. As it is, for a book of the scope commissioned by a commercial history publisher, it was necessary to narrow the book’s focus somewhat. The book, therefore, presents short histories of the people who fought for political rights, from the medieval period to the granting of women’s suffrage in 1918. And when we say ‘fought for’, readers should take that to mean that we are discussing the lives of people who took part in direct action and protests. Another volume on the theme of revolutionary thinkers is planned for the future, although as this volume shows those categories are by no means mutually exclusive. In this volume, there are several "), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _vm._v("figures who straddle both categories, such as the Duke of Richmond, Thomas Paine, G.W.M. Reynolds, and William Morris, to name but a few. Yet still some characters and events have had to be omitted or referred to only tangentially, while religiously-inspired rebellions such as the Pilgrimage of Grace are not included. However, readers will find that although several chapters, on the surface, deal with the lives and exploits of just "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("one")]), _vm._v(" major figure, authors in this volume have used the events of that figure’s life to illuminate a wider history of the people, places, and events in which those radicals took part.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container1"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fxii-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The seal of William the Conqueror. (British Library, Public Domain)")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A Norman Yoke")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("In the eighteenth century Robert Ferguson declared that:")]), _vm._v(" "), _c('div', {
    staticClass: "blockq"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("In all our histories of Great Britain and Ireland, we meet with nothing more frequent than mobs and insurrections, which tho’ they have always terminated in the destruction of the ring leaders and the principal abettors, yet we still find that the madness of the people has fatally spread itself from one age to another, and is become even at this day, no less dangerous and infectious than it was at the very beginning."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach01_4",
      "id": "ch01_4"
    }
  }, [_vm._v("4")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _vm._v("Ferguson was a Jacobite, a member of a group who, while not radical or revolutionary, did seek to depose the reigning monarch, George I, and reinstall a member of the Stuart dynasty to the throne."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach01_5",
      "id": "ch01_5"
    }
  }, [_vm._v("5")])]), _vm._v(" Whatever his personal politics, however, Ferguson was right: There have indeed been rebellions in Britain since time immemorial. When the Norman William the Conqueror invaded England with his army in 1066 and defeated King Harold Godwinson, William assumed the English throne. It was not a smooth succession. A chronicler named William of Poitiers gives the impression that the Norman conqueror and his local representatives attempted at first to placate the English:")]), _vm._v(" "), _c('div', {
    staticClass: "blockq"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("They paid the greatest respect to justice, as the king had admonished, so that fierce men and enemies might be corrected and brought into friendship. The lesser officials were equally zealous in the castles where each had been placed. But neither benefits nor fear could sufficiently force the English to prefer peace and quiet to changes and revolts."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach01_6",
      "id": "ch01_6"
    }
  }, [_vm._v("6")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("That was certainly an interpretation of events that was very friendly to the Normans. The English indeed were not quite ready to make peace with their conquerors, especially as the grievances of the English people fell on deaf ears, as Oderic Vitalis explained:")]), _vm._v(" "), _c('div', {
    staticClass: "blockq"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The king’s vice regents, were so swollen with pride that they would not deign to hear the reasonable plea of the English or give them impartial judgement. When their men-at-arms were guilty of plunder and rape they protected them by force, and wreaked their wrath all the more violently upon those who complained of the cruel wrongs they suffered. And so the English groaned aloud for their lost liberty and plotted ceaselessly to find some way of shaking off a yoke that was so intolerable and unaccustomed."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach01_7",
      "id": "ch01_7"
    }
  }, [_vm._v("7")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Shortly after Godwinson’s death, the Witengamot (the early form of parliament, or national council) elected Edgar Ætheling to be king instead of William. Ætheling encouraged the English people to rise up against their new overlords and many people did as he commanded, with the help of local nobles and foreign allies. Allied with the Welsh, an English thegn named Eadric ‘the Wild’ launched quick raids in and around Hereford before scarpering back to Wales. In 1067, a thegn named Hereward the Wake was busy fighting, with the assistance of the Danes, what is best termed a guerrilla war against the Normans in the east of England. At one point the Danes even sent an army to England and William had to pay them to return home. The north of England was also a hotbed of resistance; led by English nobles such as Gospatric, Earl of Northumbria and Edwin, Earl of Mercia, and enlisting the help of foreign soldiers, the people in the north of England might well have succeeded in ousting their foreign conquerors. Yet it was not to be. William turned nasty. He decided to punish people in the north of England by starving them out and enacting what we would now call a ‘scorched earth’ policy. These actions in the late 1060s, which have acquired the name of ‘The Harrying of the North’ were described by Vitalis:")]), _vm._v(" "), _c('div', {
    staticClass: "blockq"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _vm._v("Nowhere else had William shown such cruelty. Shamefully he succumbed to this vice, for he made no effort to restrain his fury and punished the innocent with the guilty. In his anger he commanded that all crops and herds, chattels and food of every kind should be brought together and burned to ashes with consuming fire, so that the whole region north of the Humber might be stripped of all means of sustenance. In consequence so serious a scarcity was felt in England, and so terrible a famine fell upon the humble and defenceless populace, that more than one hundred thousand Christian folk of both sexes, young and old alike, perished of hunger. My narrative has frequently had occasion to praise William, but for this act which condemned the innocent and the guilty alike to die by slow starvation I cannot commend him."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach01_8",
      "id": "ch01_8"
    }
  }, [_vm._v("8")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("We may take the number of 100,000 deaths to be a bit exaggerated but still, whatever the numbers, many people did die. It was clear that after a brutal series of repressive measures the English rising was crushed. Ætheling’s election was quietly set aside and the would-be young king was forced to bend the knee to William.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container1"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fxiv-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Magna Carta. (from a facsimile in Stephen Basdeo’s personal collection)")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3a"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("The Battle for Magna Carta")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Disputes over who should wear the crown followed after William’s death, notably the civil war between King Stephen and Matilda. But the next major revolt, with consequences which reverberate even unto our own times, was the Barons’ War against King John. Having ascended the throne after the death of his more popular brother, Richard the Lionheart, John proved to be a bad ruler. The Normans and, later, the Angevins, not only ruled England but also held extensive lands in France. John’s father, Henry II, held lands in England, Normandy, Maine, Anjou, Brittany, and Wales. Yet during John’s reign, the king of France had steadily made inroads into these domains and by 1204, most of John’s ancestral lands in France had been conquered by Philip II of France. John attempted to regain these lands but the disastrous military expeditions came at a high cost and to fund these John arbitrarily raised taxes without the consent of the barons. English monarchs had, until John, always counted themselves as above the law, although most kings accepted that it was good practice to rule "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("in accordance with")]), _vm._v(" the law. The best expression of this was the signing of the Charter of Liberties by Henry I upon his accession in 1100, which, among other things, declared that the raising of feudal dues should be kept within reasonable limits. However, subsequent monarchs largely ignored this charter and John was no different. He needed money and he wanted his French lands back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Between February and October 1214, John suffered another ignominious defeat in attempting to reconquer his French domains. It was costly. All the money that he had spent from the taxes raised appeared to have been pointlessly squandered. The English barons were angry. John had also fallen afoul of the Catholic Church. He refused to accept Pope Innocent III’s nomination for the position of Archbishop of Canterbury and the pope was so incensed at John’s obstinacy that in 1208 he placed the entire realm of England under an interdict. The barons had had enough and they decided to renounce their allegiance to John and named Robert Fitz Walter as their leader. A baronial rebellion had begun. The "), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _vm._v("rebel barons’ demanded that the king reaffirm his pledge to abide by the provisions of the Charter of Liberties and on 17 May 1215, the rebels were welcomed into the city of London by the inhabitants.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container1"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fxv-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The barons’ meeting with King John. (from Joseph Clayton’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rise of the Democracy")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("John decided to face the music and meet with the rebels on 10 June at Runnymede meadow on the banks of the Thames. The barons had drawn up a new charter which was even more wide-ranging than the Charter of Liberties from Henry I’s era: The Articles of the Barons. This document set out numerous conditions which they expected John to agree to before they would again pledge their allegiance to him. After some days of negotiations, King John affixed his seal to a new document — Magna Carta (the ‘great charter’) — and accepted all of its terms. There were sixty-three provisions dealing with the collections of taxes, the ‘ancient rights’ of boroughs and liberties, and even fishing rights. Most famously there was also a provision in clause 39 setting out in clear terms who could be arrested and how, once brought to trial, a person might be judged:")]), _vm._v(" "), _c('div', {
    staticClass: "blockq"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("No free man shall be seized, imprisoned, dispossessed, outlawed, exiled or ruined in any way, nor in any way proceeded against, except by the lawful judgement of his peers and the law of the land."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach01_9",
      "id": "ch01_9"
    }
  }, [_vm._v("9")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Contrary to popular belief, this was not actually the foundation of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("habeas corpus")]), _vm._v(", for that originated in the Assize of Clarendon in 1166."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach01_10",
      "id": "ch01_10"
    }
  }, [_vm._v("10")])]), _vm._v(" The provision in Magna Carta merely built upon an existing idea which held that, if the authorities wanted to arrest someone, there had to be sufficient evidence of wrongdoing before they were allowed to. Hence clause 38 of Magna Carta: ‘In future no official shall place a man on trial upon his own unsupported statement, without producing credible witnesses to the truth of it’."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach01_11",
      "id": "ch01_11"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On 15 June 1215, King John accepted the terms of the Magna Carta and set his seal upon a draft of it. Four days later the barons pledged their allegiance to John again. The king now had to act within the law.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Or so the barons thought.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("John had made amends with Pope Innocent III two years earlier by accepting Stephen Langton, the Pope’s choice, as Archbishop of Canterbury. John got the interdict lifted and submitted to ruling England as a Papal Fief, with England forced to pay an annual tribute to the pope. Having signed Magna Carta, John appealed to Innocent and asked him to annul Magna Carta because it had been signed under duress. The Pope promptly took John’s side and on 7 July 1215, the pontiff excommunicated all of the barons who rebelled against their king and on 25 August, the pope formally declared Magna Carta null and void.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yet the barons would have their way. In September 1215, they rebelled against John again. But it was to be a short rebellion for on 16 October, King John died at Newark. Twelve days later, Henry III was crowned King of England at Gloucester and on 12 November, Magna Carta was reissued by young Henry’s government, with some minor changes, and a third version was issued again on 6 November 1217, again with some minor changes. However, in the summer of 1224, the King of France invaded La Rochelle and Poitu—what was left of the Angevin domains in France—which required a new war, and new taxes, to fund its defence. Nevertheless, the English were "), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _vm._v("expelled from these regions were formally incorporated into the French royal lands. However, this event did mean that in 1225 Henry III had to once again publicly signal his intention to abide by the terms of Magna Carta.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The De Montfort Rebellion")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("A young French nobleman arrived in England in 1229 and sought an audience with the king. His name was Simon de Montfort. Born in the early part of the century, de Montfort relinquished the rights to his lands in France, thereby absolving himself of any allegiance to the French king, and petitioned Henry III to be given an English inheritance. Land was granted to de Montfort and he even married the king’s sister Eleanor. A fervent, bigoted Christian, he expelled the Jewish people from his land in Leicester which won him a lot of popularity in the eyes of the locals."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach01_12",
      "id": "ch01_12"
    }
  }, [_vm._v("12")])]), _vm._v(" Yet he made a bit of a blunder—he was in debt to Thomas II of Savoy and, without consulting his brother-in-law Henry III, listed the king as a guarantor of his debt. The king was furious. De Montfort, perhaps wisely, decided to leave England for a bit and go on crusade.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By 1254, de Montfort was back in England, having made a somewhat frosty reconciliation with the king. In the same year, the king demanded more subsidies from the nobles in order to pay the Pope, who, after receiving payment, would allow Henry III’s son to inherit the throne of Sicily. When the king summoned the nobles to a parliament in 1258 to deliberate on the king’s financial matters, de Montfort was one of the leading voices who were opposed to granting the king more money. The parliament agreed the Provisions of Oxford which placed limits on the power of the king by appointing a privy council—comprising twelve of the king’s men and twelve of the reformers’ men—to oversee the king’s government. The two chief ministers of this council, the Justiciar and the Chancellor, were to be chosen by its members. The Privy Council would then be accountable to the nobles when parliaments were convened.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The king granted the money to pay the Pope but the nobles still wanted Henry III to be accountable to them through the Privy Council. Tensions were brewing because the king wanted to completely scrap the Provisions of Oxford. The Pope formally annulled the Provisions of Oxford in 1261. This did not go down well with the nobles and, frustrated, de Montfort left England. He left a country on the brink of civil war.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For two years the remaining barons tried to persuade the king to pledge his support again to the Provisions of Oxford. Frustrated with the king’s stubbornness, when de Montfort returned in 1263, the barons asked him to lead a rebellion with the sole aim of compelling the king to agree to abide by the terms of the Provisions of Oxford. An army was raised and the de Montfort’s forces began attacking the estates of the king’s allies. Into the fray, the King of France stepped forth as a supposedly impartial adjudicator. Having listened to the arguments of both sides he ruled in Henry’s favour. This did not satisfy either de Montfort or the barons and further skirmishes ensued. At the Battle of Lewes on 14 May 1264, the king was captured and forced to sign the Mise of Lewes which, although this document no longer survives, compelled the king to pardon the rebels and abide by the terms of the Provisions of Oxford. In the words of "), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }), _vm._v("Adrian Jobson, the king was now ‘little more than a figurehead’."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach01_13",
      "id": "ch01_13"
    }
  }, [_vm._v("13")])]), _vm._v(" The king’s son Prince Edward was also taken by the barons as a hostage—an extra incentive for the king to keep his word.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("De Montfort was effectively England’s ruler, although he claimed power in the king’s name. He summoned a parliament to confirm the terms of his government but, upon hearing of widespread discontent across the country and with the support of the barons ebbing away now the king had been brought to heel, de Montfort tried to win legitimacy for his administration by summoning another parliament in 1265. Parliaments had been summoned before this but de Montfort’s 1265 convening of parliament was truly innovative. He summoned the nobles, bishops and the knights as usual but also—something which had never happened before—representatives of the non-noble burgesses. Commoners were now being given a voice in the affairs of government. Let us not fall into the trap of believing this to be some sort of non-partisan and democratic assembly, however, for de Montfort made sure to stuff this new parliament with those who were friendly to his cause."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach01_14",
      "id": "ch01_14"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("De Montfort’s parliament offered a temporary reprieve for the unrest in the country but several of the nobles now began to oppose him. There were rumours that he was enriching himself at the expense of the public. He did indeed gain a handsome fortune at this time. To add to de Montfort’s woes Prince Edward escaped and, vowing to put an end to de Montfort’s rule, raised an army and went into battle with de Montfort at the Battle of Evesham on 4 August 1265. De Montfort fell in battle here. His body was found on the battlefield and was decapitated. His testicles, his hands, and his feet were also dismembered."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach01_15",
      "id": "ch01_15"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container1"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fxviii-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The Death of Simon de Montfort. (British Library, Public Domain)")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The reforms which de Montfort introduced would outlast him, however. Successive parliaments summoned by Henry III sometimes included non-nobles or representatives of the ‘commons’. His son Edward, when he ascended the throne in 1272, actually continued de Montfort’s practice of summoning both nobles and representatives of the commons to parliament. In the next century, the representatives of the nobles and the commons were split into two ‘houses’. The House of Commons and the House of Lords were born, although England was by no means democratic in any sense of the word.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_xix"
    }
  }), _vm._v("The commons had been ‘invited’ to have a say in the affairs of the government because a discontented nobleman, de Montfort, needed to win legitimacy for his administration. Yet neither de Montfort’s rebellion, nor the First Barons’ War against King John were ‘popular’ rebellions. That is to say that, in spite of their importance, in neither case did the people rise up and demand their rights. The first time this would happen in England would be in the fourteenth century, and so I begin this collection of essays with an account of perhaps the most famous ‘popular’ rebellion in English history: The Peasants’ Revolt of 1381.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch01_1",
      "id": "ach01_1"
    }
  }, [_vm._v("1")]), _vm._v(". “Clayton, Joseph,” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Catholic Encyclopedia and Its Makers")]), _vm._v(", ed. Charles Herbermann et al (New York, the Encyclopedia Press, 1917), 30")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch01_2",
      "id": "ach01_2"
    }
  }, [_vm._v("2")]), _vm._v(". Joseph Clayton, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Rise of the Democracy")]), _vm._v(" (London: Cassell, 1911), accessed 15 April 2020, "), _c('a', {
    attrs: {
      "href": "http://www.gutenberg.org/files/19609/19609-h/19609-h.htm",
      "target": "_blank"
    }
  }, [_vm._v("http://www.gutenberg.org/files/19609/19609-h/19609-h.htm")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch01_3",
      "id": "ach01_3"
    }
  }, [_vm._v("3")]), _vm._v(". Michael J. Turner, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Independent Radicalism in Early Victorian Britain")]), _vm._v(" (Westport, CT: Praegar, 2004), 2–4.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch01_4",
      "id": "ach01_4"
    }
  }, [_vm._v("4")]), _vm._v(". Robert Ferguson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The History of all the Mobs, Tumults, and Insurrections in Great Britain, from William the Conqueror to the Present Time. To Which is Added, The Act of Parliament and Proclamation Lately Publish’d for Punishing Rioters")]), _vm._v(" (London: Printed for J. Moore near St. Paul’s, 1715), i.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch01_5",
      "id": "ach01_5"
    }
  }, [_vm._v("5")]), _vm._v(". Melinda S. Zook, “Turncoats and Double Agents in Restoration and Revolutionary England: The Case of Robert Ferguson, the Plotter,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Eighteenth-Century Studies")]), _vm._v(" 42 no. 3 (2009): 363-378.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch01_6",
      "id": "ach01_6"
    }
  }, [_vm._v("6")]), _vm._v(". William of Poitiers, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gesta Guillelmi")]), _vm._v(", ed. R.H.C Davis and Marjorie Chibnall (Oxford: Oxford University Press, 1998), 46.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch01_7",
      "id": "ach01_7"
    }
  }, [_vm._v("7")]), _vm._v(". Oderic Vitalis, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Historia Ecclesiastica")]), _vm._v(", trans. Auguste le Provoste, 5 vols. (Paris: Société de l’histoire de France, 1838–1855), II, 46.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch01_8",
      "id": "ach01_8"
    }
  }, [_vm._v("8")]), _vm._v(". Vitalis, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Historia Ecclesiastica")]), _vm._v(", vol. 2, 195–96.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch01_9",
      "id": "ach01_9"
    }
  }, [_vm._v("9")]), _vm._v(". UK Parliament, “The contents of Magna Carta,” accessed April 4, 2020. Available at: "), _c('a', {
    attrs: {
      "href": "http://www.parliament.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.parliament.uk")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch01_10",
      "id": "ach01_10"
    }
  }, [_vm._v("10")]), _vm._v(". “Assize of Clarendon, 1166,” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Select Historical Documents of the Middle Ages")]), _vm._v(", ed. Ernest F. Henderson (London: George Bell and Sons, 1896), 146.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch01_11",
      "id": "ach01_11"
    }
  }, [_vm._v("11")]), _vm._v(". British Library, “Magna Carta,” accessed April 1, 2020. Available at: "), _c('a', {
    attrs: {
      "href": "http://www.bl.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.bl.uk")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch01_12",
      "id": "ach01_12"
    }
  }, [_vm._v("12")]), _vm._v(". Oliver Harris, “Jews, jurats and the Jewry Wall: a name in context,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Transactions of the Leicestershire Archaeological and Historical Society")]), _vm._v(" 82 (2008): 113–33 (129–31).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch01_13",
      "id": "ach01_13"
    }
  }, [_vm._v("13")]), _vm._v(". Adrian Jobson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The First English Revolution: Simon de Montfort, Henry III and the Barons’ War")]), _vm._v(" (London: Bloomsbury, 2012), 117–122.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch01_14",
      "id": "ach01_14"
    }
  }, [_vm._v("14")]), _vm._v(". Jeffrey Hamilton, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Plantagenets: History of a Dynasty")]), _vm._v(" (London: Continuum, 2010), 46.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch01_15",
      "id": "ach01_15"
    }
  }, [_vm._v("15")]), _vm._v(". J.R. Maddicott, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Simon de Montfort")]), _vm._v(" (Cambridge: Cambridge University Press, 1994), 342."), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ea652e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Introduction.vue
// module id = 75
// module chunks = 0